export * from '../../components/Tabs/TabsV2';
export type { TabsProps } from '../../components/Tabs/types';
